import { Component, ViewEncapsulation, OnInit, signal } from '@angular/core';
import { UserService } from '../../../../../shared/services/user.service';
import { TableModule } from 'primeng/table';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeadingComponent } from '../../../../../shared/components/heading/heading.component';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
 DynamicDialogModule } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { DynamicTableComponent } from './dynamic-table/dynamic-table.component';
import { DynamicCredentialService } from '../../../../../shared/services/dynamic-credential.service';
import { constants } from '../../../../../shared/constants/constants';
import { DynamicCredential } from '../../../../../shared/interfaces/settings.interface';
import { SessionUser } from '../../../../../store/user/user.interface';
import { getSessionFirm } from '../../../../../store/user/user.selector';
import { Store } from '@ngrx/store';
import { FamilySettingsBannerComponent } from '../../../../../shared/components/family-settings-banner/family-settings-banner.component';

@Component({
  selector: 'app-dynamic-credential',
  standalone: true,
  imports: [
    CheckboxModule,
    FloatLabelModule,
    DialogModule,
    ButtonModule,
    FormsModule,
    IconFieldModule,
    InputIconModule,
    HeadingComponent,
    InputTextModule,
    TableModule,
    CommonModule,
    ReactiveFormsModule,
    DynamicDialogModule,
    DynamicTableComponent,
    FamilySettingsBannerComponent,
  ],
  providers: [DialogService, DynamicDialogRef, DynamicDialogConfig],
  templateUrl: './dynamic-credential.component.html',
  styleUrl: './dynamic-credential.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class DynamicCredentialComponent implements OnInit {
  dynamicCredential!: DynamicCredential[];
  dynamicCredentialTitle: string = constants.dynamicCredential.title;
  firm: any;

  /**
   * MP-5638/MP-5641: taxonomy administration is FM-only inside a family.
   *
   * The firm's `isDynamicFirmSettingsEnabled` flag still decides whether the
   * feature is available at all; this is ANDed with it so the create, edit,
   * archive and delete controls are hidden from a user the server would
   * refuse. See `UserService.canManageTaxonomy()`.
   */
  readonly canManageTaxonomy = signal(false);

  ref: DynamicDialogRef | undefined;
  userFirmId!: string;
  
  constructor(
    private userService: UserService,
    public dialogService: DialogService,
    private router: Router,
    private store: Store<SessionUser>,
    public config: DynamicDialogConfig,
    public dynamicCredentialService: DynamicCredentialService
  ) {}

  ngOnInit(): void  {
    // MP-5653: definitions are PARENT-owned, so read them at the family root
    // regardless of the acting child in the header. Same id for a standalone firm.
    this.userFirmId = this.userService.getFamilyRootFirmId();
    this.canManageTaxonomy.set(this.userService.canManageTaxonomy());
    this.getFirm();
    this.getDynamicCredential();
  }

  getFirm(){
    this.store.select(getSessionFirm).subscribe((res) => {
      this.firm = res;
    });
  }

  getDynamicCredential(): void {
    this.dynamicCredentialService
      .getFirmDynamicCredential(this.userFirmId)
      .subscribe({
        next: (dynamicCred: {list : DynamicCredential[]}) => {
          this.dynamicCredential = dynamicCred.list;
        },
      });
  }

  handleRefresh(): void  {
    this.getDynamicCredential();
  }

  goToCreate(): void  {
    this.router.navigateByUrl(
      'client/settings/dynamic-credential/create'
    );
  }

}